import { SxProps, Theme } from "@mui/material";

export const bookingCardStyles = {
  card: (theme: Theme): SxProps<Theme> => ({
    borderRadius: "12px",
    marginBottom: "24px",
    cursor: "pointer",
    fontFamily: theme.typography.fontFamily,
    width: { xs: "auto", sm: "100%" },
    // [theme.breakpoints.down("sm")]: {
    //   width: "350px",
    // },
    boxShadow:'none',
    padding: "8px 24px 8px 8px",
    border: "1px solid #8D8D8D",
    display: "flex",
    gap: "24px",
    flexDirection: {xs: "column", sm: "row"},
    position: "relative"
  }),
  imageBox: {
    borderRadius: "50%",
  },
  image: {
    width: "174px",
    height: "174px",
    objectFit: "cover" as const,
    display: "block",
    borderRadius: "50%",
  },
  detailsContainer: { padding: "0px", width: "100%" },
  title: {
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "5px",
  },
  lightText: {
    fontSize: "15px",
    fontWeight: "400",
    color: "#000",
  },
  iconContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "11px",
  },
  darkText: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#000",
  },
  lightSmallText: {
    fontSize: "15px",
    fontWeight: "400",
    color: "#000",
  },

    lightSmallText1: {
    fontSize: "15px",
    fontWeight: "400",
    color: "#595959",
  },
  zeroRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  commonRow: {
    display: "flex",
    flexDirection: {xs: "column", md: "row"},
    gap: "10px",
  },
  bookingPriceRow: {
    display: "flex",
    flexDirection: "row",
    gap: "30px",
    marginTop: "4px",
    marginBottom: "6px",
  },
  dot: {
    width: "5px",
    height: "5px",
    backgroundColor: "#000",
    borderRadius: "10px",
    marginTop: "8px",
  },
  canceledBanner: {
    backgroundColor: "#ffcccc",
    alignItems: "center",
    // position: "absolute",
    width: "100px",
    display: "flex",
    justifyContent: "center",
    borderRadius: "6px",
    padding: "2px",
    // right: "4px",
    // top: "4px",
  },
  canceledText: {
    color: "#cc0000",
    fontWeight: "500",
    fontSize: "14px",
  },

  rowBetween: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  businessNameContainer: {
    width: "70%",
  },
  commissionContainer: {
    width: "30%",
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    justifyContent: "flex-end",
  },
  commissionText: {
    fontSize: "15px",
    fontWeight: "400",
    color: "#000",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },
  dotSeparator: {
    width: "5px",
    height: "5px",
    backgroundColor: "#000",
    borderRadius: "10px",
    marginTop: "8px",
  },
};